/**
 * RecoveryPage - Восстановление пароля
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { registrationService } from "../../api/services/registrationService";
import { apiClient } from "../../api/client";
import { AuthLayout } from "../../components/layouts";

const RecoveryPage = () => {
    const [stage, setStage] = useState(1);
    const [targetTimer, setTargetTimer] = useState(60);
    const [error, setError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [emailState, setEmailState] = useState("");
    const navigate = useNavigate();

    const handleRecoverySubmit = async (event) => {
        event.preventDefault();
        setError("");
        setIsSubmitting(true);

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        try {
            const data = await apiClient.post(
                `${process.env.REACT_APP_API_URL}api/users/recovery-pass`,
                payload,
                false,
                false,
            );
            if (data === true) {
                const email = payload.email || "";
                localStorage.setItem("user-email", email);
                setEmailState(email);
                setStage(2);
                setTargetTimer(60);
            } else {
                setError(
                    data?.message ||
                        "Произошла ошибка. Проверьте введенные данные.",
                );
            }
        } catch (err) {
            console.error("Ошибка соединения:", err);
            setError("Ошибка соединения с сервером.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e, index) => {
        const value = e.target.value;
        if (/^\d$/.test(value)) {
            const nextInput = document.getElementById(`pincode-${index + 1}`);
            if (nextInput) nextInput.focus();
        } else {
            e.target.value = "";
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && e.target.value === "") {
            const prevInput = document.getElementById(`pincode-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
    };

    const handleResendMail = async () => {
        const email = emailState || localStorage.getItem("user-email");
        if (targetTimer > 0 || !email) return;
        try {
            const result = await registrationService.sendVerifyCode(email);
            if (result === true) {
                setTargetTimer(60);
            } else {
                setError("Не удалось отправить код, попробуйте позже.");
            }
        } catch (err) {
            console.error("Ошибка соединения:", err);
            setError("Ошибка соединения при отправке письма.");
        }
    };

    const SubmitCode = async (event) => {
        event.preventDefault();
        setError("");
        setIsVerifying(true);

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        const code =
            (payload["pincode-1"] || "") +
            (payload["pincode-2"] || "") +
            (payload["pincode-3"] || "") +
            (payload["pincode-4"] || "") +
            (payload["pincode-5"] || "") +
            (payload["pincode-6"] || "");

        const email = emailState || localStorage.getItem("user-email");

        try {
            const data = await apiClient.post(
                `${process.env.REACT_APP_API_URL}api/users/submit-recovery`,
                { code, email },
                false,
                false,
            );

            if (data === true) {
                alert(
                    "Письмо с дальнейшими инструкциями было выслано на ваш e-mail.",
                );
                localStorage.removeItem("user-email");
                setTimeout(() => navigate("/"), 2500);
            } else {
                setError(data?.message || "Неверный код подтверждения.");
            }
        } catch (err) {
            console.error("Ошибка соединения:", err);
            setError("Ошибка соединения с сервером.");
        } finally {
            setIsVerifying(false);
        }
    };

    // Таймер
    useEffect(() => {
        if (targetTimer > 0) {
            const timer = setTimeout(() => {
                setTargetTimer(targetTimer - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [targetTimer]);

    return (
        <AuthLayout>
            {stage === 1 ? (
                <div className="recovery-container">
                    <span className="recovery-title">
                        ВОССТАНОВЛЕНИЕ ПАРОЛЯ
                    </span>
                    {error && <span className="auth-error-span">{error}</span>}
                    <form
                        onSubmit={handleRecoverySubmit}
                        className="recovery-form"
                    >
                        <input
                            className="recovery-input-form"
                            placeholder="Имя аккаунта*"
                            type="text"
                            name="login"
                            maxLength={20}
                            minLength={3}
                            required
                        />
                        <input
                            className="recovery-input-form"
                            placeholder="Email*"
                            type="email"
                            name="email"
                            maxLength={64}
                            minLength={6}
                            required
                        />
                        <button
                            className="recovery-button-next"
                            type="submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting
                                ? "Отправка..."
                                : "ВОССТАНОВИТЬ ПАРОЛЬ"}
                        </button>
                    </form>
                </div>
            ) : stage === 2 ? (
                <div className="recovery-container">
                    <span className="recovery-title">
                        ВОССТАНОВЛЕНИЕ ПАРОЛЯ
                    </span>
                    <span>
                        На электронную почту вам было выслано письмо
                        подтверждения. Пожалуйста, введите код из письма в поля
                        ниже.
                    </span>
                    {error && <span className="auth-error-span">{error}</span>}
                    <form onSubmit={SubmitCode} className="recovery-form">
                        <div className="code-input-container">
                            {[...Array(6)].map((_, i) => (
                                <input
                                    key={i}
                                    id={`pincode-${i + 1}`}
                                    className="code-input-number"
                                    maxLength={1}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    type="tel"
                                    name={`pincode-${i + 1}`}
                                    onChange={(e) =>
                                        handleInputChange(e, i + 1)
                                    }
                                    onKeyDown={(e) => handleKeyDown(e, i + 1)}
                                />
                            ))}
                        </div>

                        <span className="recovery-span-timer">
                            {targetTimer > 0
                                ? `Вы сможете переотправить письмо через ${targetTimer} секунд`
                                : "Вы можете переотправить письмо."}
                        </span>

                        <button
                            type="button"
                            className="ucp-simple-blur-button"
                            onClick={handleResendMail}
                            disabled={targetTimer > 0}
                        >
                            ПЕРЕОТПРАВИТЬ ПИСЬМО
                        </button>

                        <button
                            className="recovery-button-next"
                            type="submit"
                            disabled={isVerifying}
                        >
                            {isVerifying ? "Проверка..." : "ПОДТВЕРДИТЬ"}
                        </button>
                    </form>
                </div>
            ) : null}
        </AuthLayout>
    );
};

export default RecoveryPage;
